import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import api from "../services/api";
import { loginSuccess } from "../features/auth/authSlice";

import Alert from "./Alert";
import { MOCK_AUTH_RESPONSE } from "../config/mockResponses";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [alert, setAlert] = useState({
    type: "",
    message: ""
  });

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const submit = async () => {
    setAlert({ type: "", message: "" });

    if (!username || !password) {
      setAlert({
        type: "error",
        message: "Email and password are required"
      });
      return;
    }

    try {
      const res = await api.post(
        "https://aihealth.ascendeongroup.com/api-dev/auth/login",
        {
          email: username,
          password: password
        },
        {
          headers: {
            "Content-Type": "application/json",
            accept: "application/json"
          }
        }
      );

      const { access_token, role } = res.data;

      if (!access_token || !role) {
        throw new Error("Invalid login response");
      }

      // Normalize role (API returns ADMIN / BUSINESS)
      const normalizedRole = role.toLowerCase();

      dispatch(
        loginSuccess({
          token: access_token,
          role: normalizedRole
        })
      );

      setAlert({
        type: "success",
        message: "Login successful"
      });

      setTimeout(() => {
        navigate("/admin/materialize");
        // if (normalizedRole === "business") {
        //   navigate("/cohort");
        // } else if (normalizedRole === "admin") {
        //   navigate("/admin/materialize");
        // }

      }, 1000);

    } catch (err) {
      console.error("Login failed", err);

      setAlert({
        type: "error",
        message: "Invalid email or password"
      });
    }
  };



  return (
    <div className="login-page">
      <div className="login">
        <h2>Login</h2>

        <Alert type={alert.type} message={alert.message} />

        <input
          placeholder="Username"
          value={username}
          onChange={e => setUsername(e.target.value)}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        <button onClick={submit}>Login</button>
      </div>
    </div>
  );
}
